import React from "react";
import { Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { Footer } from "../components";
import { accessTokenSelector } from "../redux/auth/selectors";
import { setAuth } from "../redux/profile/authAndReg/slice";

const PageLayout: React.FC = () => {
  const dispatch = useDispatch();
  const accessToken = useSelector(accessTokenSelector);

  React.useEffect(() => {
    if (accessToken) {
      dispatch(setAuth(accessToken));
    }
  }, [accessToken, dispatch]);

  return (
    <div className="wrapper">
      <Outlet />
      <Footer />
    </div>
  );
};

export default PageLayout;
